import * as stylex from '@stylexjs/stylex'
import { type ElementType, type PropsWithChildren } from 'react'
import { Box, type BoxProps } from '../Box/Box'

const baseStyles = stylex.create({
  root: {
    padding: '12px 16px',
    gap: 10,
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'flex-end',
  },
})

/**
 * DialogActions 的屬性，繼承自 BoxProps。
 */
export type DialogActionsProps<RootComponent extends ElementType = 'div', BoxElement extends HTMLElement = HTMLDivElement> = BoxProps<RootComponent, BoxElement>

/**
 * DialogActions 對話框底部操作按鈕區域元件。
 * 預設將子元素靠右對齊排列。
 */
export const DialogActions = <RootComponent extends ElementType = 'div', BoxElement extends HTMLElement = HTMLDivElement>(props: PropsWithChildren<DialogActionsProps<RootComponent, BoxElement>>) => {
  const { component = 'div', rootStyle, ...rest } = props
  return (
    <Box
      component={component}
      rootStyle={[baseStyles.root, rootStyle]}
      {...rest}
    />
  )
}
